export function gtmEvent(eventName, params = {}) {
    // Push to GTM dataLayer
    if (window.dataLayer) {
        window.dataLayer.push({
            event: eventName,
            ...params,
        });
    }
}
